<nz-spin
  [nzIndicator]="indicatorTemplate"
  [nzSize]="'large'"
  [nzSpinning]="loadingPersonalDetails || loadingToggleMode"
  [nzTip]="'COMMON.LOADING_DATA' | translate">
  @if (mode !== 'foreigner') {
    <button
      matButton="elevated"
      [class.form-enabled]="!personalDataForm.disabled"
      class="toggle-form-enablement-button"
      (click)="toggleFormEnabled()">
      @if (personalDataForm.disabled) {
        {{ 'MANAGEMENT.ACTIVATE_FORM_EDIT_MODE' | translate }}
      } @else {
        {{ 'MANAGEMENT.DEACTIVATE_FORM_EDIT_MODE' | translate }}
      }
    </button>
  }

  @if (categoryForm === PROCESS_CATEGORY.TEMP_PREMIT) {
    <app-temp-premit-form
      [userProcess]="userProcess"
      [currentLang]="currentLang"
      [loadingUserProcess]="loadingUserProcess"
      [errorMessage]="errorMessage"
      [mode]="mode"
      (updateDetails)="updateDetails.emit($event)"
      (confirmVoivoChange)="confirmVoivoChange.emit($event)"
      (toggleVerificationOfPersonalDetails)="toggleVerificationOfPersonalDetails.emit($event)"
      (confirmDetails)="confirmDetails.emit($event)"
      [correctlyFilledSteps]="correctlyFilledSteps"
      [personalDataForm]="personalDataForm"
      [bottomActionBarInFlow]="bottomActionBarInFlow"
      [percentageOfCompletness]="percentageOfCompletness"
      [totalStepsInForm]="totalStepsInForm"
      [dateFormatsForFields]="dateFormatsForFields">
    </app-temp-premit-form>
  }
  @if (categoryForm === PROCESS_CATEGORY.LONG_RESI) {
    <app-long-resi-form
      [userProcess]="userProcess"
      [currentLang]="currentLang"
      [loadingUserProcess]="loadingUserProcess"
      [errorMessage]="errorMessage"
      [mode]="mode"
      (updateDetails)="updateDetails.emit($event)"
      (confirmVoivoChange)="confirmVoivoChange.emit($event)"
      (toggleVerificationOfPersonalDetails)="toggleVerificationOfPersonalDetails.emit($event)"
      (confirmDetails)="confirmDetails.emit($event)"
      [correctlyFilledSteps]="correctlyFilledSteps"
      [personalDataForm]="personalDataForm"
      [bottomActionBarInFlow]="bottomActionBarInFlow"
      [percentageOfCompletness]="percentageOfCompletness"
      [totalStepsInForm]="totalStepsInForm"
      [dateFormatsForFields]="dateFormatsForFields">
    </app-long-resi-form>
  }
  @if (categoryForm === PROCESS_CATEGORY.PERM_STAY) {
    <app-perm-stay-form
      [userProcess]="userProcess"
      [currentLang]="currentLang"
      [loadingUserProcess]="loadingUserProcess"
      [errorMessage]="errorMessage"
      [mode]="mode"
      (updateDetails)="updateDetails.emit($event)"
      (confirmVoivoChange)="confirmVoivoChange.emit($event)"
      (toggleVerificationOfPersonalDetails)="toggleVerificationOfPersonalDetails.emit($event)"
      (confirmDetails)="confirmDetails.emit($event)"
      [correctlyFilledSteps]="correctlyFilledSteps"
      [personalDataForm]="personalDataForm"
      [bottomActionBarInFlow]="bottomActionBarInFlow"
      [percentageOfCompletness]="percentageOfCompletness"
      [totalStepsInForm]="totalStepsInForm"
      [dateFormatsForFields]="dateFormatsForFields">
    </app-perm-stay-form>
  }
  @if (categoryForm === PROCESS_CATEGORY.CUKR) {
    <app-cukr-form
      [userProcess]="userProcess"
      [currentLang]="currentLang"
      [loadingUserProcess]="loadingUserProcess"
      [errorMessage]="errorMessage"
      [mode]="mode"
      (updateDetails)="updateDetails.emit($event)"
      (confirmVoivoChange)="confirmVoivoChange.emit($event)"
      (toggleVerificationOfPersonalDetails)="toggleVerificationOfPersonalDetails.emit($event)"
      (confirmDetails)="confirmDetails.emit($event)"
      [correctlyFilledSteps]="correctlyFilledSteps"
      [personalDataForm]="personalDataForm"
      [bottomActionBarInFlow]="bottomActionBarInFlow"
      [percentageOfCompletness]="percentageOfCompletness"
      [totalStepsInForm]="totalStepsInForm"
      [dateFormatsForFields]="dateFormatsForFields">
    </app-cukr-form>
  }
</nz-spin>
<ng-template #indicatorTemplate>
  <span nz-icon nzType="loading" class="ant-spin-dot"></span>
</ng-template>
